import React from 'react';
import Layout from '@4c/layout';
import Form from '@bfly/ui/Form';
import {
  CustomEarnings,
  CustomEarningsSchema,
} from '../models/CustomEarnings';

interface Props {
  submitForm: (value: CustomEarnings) => Promise<CustomEarnings>;
}

function CustomEarningsForm({ submitForm }: Props) {
  return (
    <Form schema={CustomEarningsSchema as any} submitForm={submitForm}>
      <Form.FieldGroup name="username" label="Username" autoFocus horizontal />

      <Form.FieldGroup name="title" label="Title" horizontal />
      <Form.FieldGroup name="description" label="Description" horizontal />
      <Form.FieldGroup name="amount" label="Amount" horizontal />

      <Layout justify="flex-end">
        <Form.Submit>Save</Form.Submit>
      </Layout>
    </Form>
  );
}

export default CustomEarningsForm;
